/**
 * Encryption Service
 *
 * Handles user encryption key management operations
 */

import { BaseService } from "../base/BaseService";

const AUTH_SERVICE_URL = "v1/auth";

export interface EncryptionKeyData {
  encrypted_key: string;
  salt?: string | null;
}

/**
 * Encryption Service
 * Handles all encryption key-related operations
 */
export class EncryptionService extends BaseService {
  constructor() {
    super(AUTH_SERVICE_URL);
  }

  /**
   * Get user's encryption key
   * GET /encryption-keys/:userId
   */
  async getUserEncryptionKey(userId: string): Promise<EncryptionKeyData | null> {
    const response = await this.get<{ success: boolean; data: EncryptionKeyData | null }>(
      `/encryption-keys/${userId}`
    );
    return response.data;
  }

  /**
   * Create or update user's encryption key
   * POST /encryption-keys
   */
  async createOrUpdateEncryptionKey(
    userId: string,
    encryptedKey: string,
    salt?: string | null,
    options?: { forceReplace?: boolean }
  ): Promise<EncryptionKeyData> {
    const response = await this.post<{ success: boolean; data: EncryptionKeyData }>(
      "/encryption-keys",
      {
        userId,
        encryptedKey,
        salt,
        forceReplace: Boolean(options?.forceReplace),
      }
    );
    return response.data;
  }

  /**
   * Delete all encryption keys for the current user
   * DELETE /encryption-keys
   */
  async deleteUserEncryptionKeys(): Promise<void> {
    await this.delete<{ success: boolean }>("/encryption-keys");
  }
}
